module.exports = __webpack_public_path__ + "static/media/DataIntegration.ed70c45b.svg";